import axiosInstance from 'integration/axiosInstance';
import { LegalEntityDto } from './models';

export const LegalEntityAPI = {
  getLegalEntity: () => {
    return axiosInstance.get<LegalEntityDto[]>(`/api/investor/legal-entity`);
  },
};
